module.exports = __webpack_public_path__ + "img/icn_receipt_white.5a302cd7.svg";